var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "identification-form" } },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-id-card",
            backPath: "/parameters/identifications",
          },
        },
        [_c("h1", [_vm._v(_vm._s(_vm.pageTitle))])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row align-items-center justify-content-center full-height",
        },
        [
          _c(
            "div",
            { staticClass: "col-12 col-lg-6 d-flex justify-content-center" },
            [
              _c("IDCard", {
                attrs: {
                  imageLink: _vm.identification.picture,
                  serial: _vm.identification.serial,
                  title: _vm.identification.name,
                  comment: _vm.identification.comment,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-lg-6" },
            [
              _c("UiCard", [
                _c("form", { staticClass: "form p-0" }, [
                  _c("div", { staticClass: "form-row row" }, [
                    _c("label", { staticClass: "col-4" }, [
                      _vm._v(_vm._s(_vm.$t("identification.serial"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.identification.serial,
                          expression: "identification.serial",
                        },
                        { name: "validate", rawName: "v-validate" },
                      ],
                      staticClass: "form-input col",
                      attrs: {
                        type: "text",
                        name: "serial",
                        "data-vv-rules": "required",
                        "data-vv-as": _vm.$t("identification.serial"),
                      },
                      domProps: { value: _vm.identification.serial },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.identification,
                            "serial",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showErrors["serial"] &&
                              _vm.errors.has("serial"),
                            expression:
                              "showErrors['serial'] && errors.has('serial')",
                          },
                        ],
                        staticClass: "form-input-error",
                        on: {
                          click: function ($event) {
                            return _vm.hideError("serial")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.errors.first("serial")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row row" }, [
                    _c("label", { staticClass: "col-4" }, [
                      _vm._v(_vm._s(_vm.$t("identification.name"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.identification.name,
                          expression: "identification.name",
                        },
                        { name: "validate", rawName: "v-validate" },
                      ],
                      staticClass: "form-input col",
                      attrs: {
                        type: "text",
                        name: "name",
                        "data-vv-rules": "required",
                        "data-vv-as": _vm.$t("identification.name"),
                      },
                      domProps: { value: _vm.identification.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.identification,
                            "name",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showErrors["name"] && _vm.errors.has("name"),
                            expression:
                              "showErrors['name'] && errors.has('name')",
                          },
                        ],
                        staticClass: "form-input-error",
                        on: {
                          click: function ($event) {
                            return _vm.hideError("name")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.errors.first("name")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row row" }, [
                    _c("label", { staticClass: "col-4" }, [
                      _vm._v(_vm._s(_vm.$t("identification.language"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.identification.language,
                            expression: "identification.language",
                          },
                        ],
                        staticClass: "form-input col",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.identification,
                              "language",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "null" } }, [
                          _vm._v("Aucune"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.languages, function (lang, key) {
                          return _c("option", { domProps: { value: key } }, [
                            _vm._v(_vm._s(lang)),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showErrors["language"] &&
                              _vm.errors.has("language"),
                            expression:
                              "showErrors['language'] && errors.has('language')",
                          },
                        ],
                        staticClass: "form-input-error",
                        on: {
                          click: function ($event) {
                            return _vm.hideError("language")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.errors.first("language")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row row" }, [
                    _c("label", { staticClass: "col-4" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("identification.comment")) +
                          "\n                        "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            position: "relative",
                            "margin-left": "10px",
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fa fa-question-circle text-warning warning-beepiz-remote-monitoring show",
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tooltip left",
                              staticStyle: {
                                width: "250px",
                                top: "-2px",
                                left: "37px",
                              },
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticStyle: {
                                    color: "#ffc107",
                                    "font-weight": "700",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("identification.tooltip.title")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$t("identification.tooltip.content")
                                  ) +
                                  "\n                                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.identification.comment,
                          expression: "identification.comment",
                        },
                      ],
                      staticClass: "form-input col",
                      domProps: { value: _vm.identification.comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.identification,
                            "comment",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row row" },
                    [
                      _c("label", { staticClass: "col-4" }, [
                        _vm._v(_vm._s(_vm.$t("identification.photo"))),
                      ]),
                      _vm._v(" "),
                      _c("PhotoInput", {
                        ref: "IDPhoto",
                        staticClass: "square",
                        attrs: {
                          id: "IDPhoto",
                          accept: "image/jpeg,image/png,image/gif",
                          margin: "0",
                          width: "200",
                          height: "200",
                          size: "1",
                          buttonClass: "action-button",
                          removeButtonClass: "action-button",
                          crop: true,
                          removable: true,
                          customStrings: {
                            upload: _vm.$t("global.form.pictureinput.upload"),
                            drag: "<img src='" + _vm.userPlaceholder + "'/>",
                            tap: _vm.$t("global.form.pictureinput.tap"),
                            change: _vm.$t("global.form.pictureinput.change"),
                            remove: _vm.$t("global.form.pictureinput.remove"),
                            select: _vm.$t("global.form.pictureinput.select"),
                            selected: _vm.$t(
                              "global.form.pictureinput.selected"
                            ),
                            fileSize: _vm.$t(
                              "global.form.pictureinput.fileSize"
                            ),
                            fileType: _vm.$t(
                              "global.form.pictureinput.fileType"
                            ),
                            aspect: _vm.$t("global.form.pictureinput.aspect"),
                          },
                        },
                        on: {
                          change: _vm.onPhotoSelect,
                          error: _vm.handlePhotoError,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "flex-row-reverse" },
        [
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-identifications",
                  expression: "'beepiz-edit-identifications'",
                },
              ],
              staticClass: "primary",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.validForm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("global.save")))]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            [
              _c(
                "router-link",
                { attrs: { to: "/parameters/identifications", tag: "span" } },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }